import React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Formatter from '../../utils/Formatter';

const Overview = ({ analysisCollection }) => {
    return (
        <div className='row'>
            <div className='col-6'>
                <Paper>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell className='text-center'>Current MMP</TableCell>
                                <TableCell className='text-center'>
                                    Current Monthly Accrual
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell className='text-center'>
                                    ${Formatter.money(analysisCollection.preview.currentMMP)}
                                </TableCell>
                                {/* This should be called  Current Monthly Accrual */}
                                <TableCell className='text-center'>
                                    ${Formatter.money(analysisCollection.preview.monthlyInterest)}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Paper>
            </div>
            <div className='col-6'>
                <Paper>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell className='text-center'>
                                    MMP with this Strategy
                                </TableCell>
                                <TableCell className='text-center'>
                                    Monthly Accrual with this Strategy
                                </TableCell>
                                <TableCell className='text-center'>
                                    Monthly Savings with this Strategy
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell className='text-center'>
                                    ${' '}{Formatter.money(analysisCollection.preview.mmp)}
                                </TableCell>
                                <TableCell className='text-center'>
                                    ${Formatter.money(analysisCollection.preview.monthAccrual )}
                                </TableCell>
                                <TableCell className='text-center'>
                                    ${Formatter.money(analysisCollection.preview.savings)}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Paper>
            </div>
            <div className='line-break' />
            <div className='col-12'>
                <Paper>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell className='text-center'>
                                    Estimated Monthly Interest Subsidy
                                </TableCell>
                                <TableCell className='text-center'>
                                    Estimated Forgiveness
                                </TableCell>
                                <TableCell className='text-center'>
                                    Estimated Payments
                                </TableCell>
                                <TableCell className='text-center'>
                                    Estimated Payoff
                                </TableCell>
                                <TableCell className='text-center'>
                                    Estimated Year of Last Payment
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell className='text-center'>
                                    ${Formatter.money(analysisCollection.preview.monthlySubsidy)}
                                </TableCell>
                                <TableCell className='text-center'>
                                    ${Formatter.money(analysisCollection.preview.forgiveness || analysisCollection.preview.outstandingBalance)}
                                </TableCell>
                                <TableCell className="text-center">
                                    {analysisCollection.preview.paymentsRemaining}
                                </TableCell>
                                <TableCell className='text-center'>
                                    ${Formatter.money(analysisCollection.preview.estimatedPayoff)}
                                </TableCell>
                                <TableCell className="text-center">
                                    {analysisCollection.preview.lastPaymentYear}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Paper>
            </div>
        </div>
    )
}

export default Overview;
